import { useTranslation } from 'react-i18next'

import { useInlineNotifications, useUk } from '../../../hooks'
import { FormikForm } from '../../Formik'

import {
  getUserInvitationFormInitialNotifications,
  getUserInvitationFormValidationSchema,
} from './UserInvitationForm.utils'
import { UserInvitationFormFields } from './UserInvitationFormFields'

function UserInvitationForm({
  FormContainer,
  containerProps,
  getInitialNotifications = getUserInvitationFormInitialNotifications,
  initialValues,
  setModal,
  onCancel,
  onClose,
  onSubmit,
  ...restProps
}) {
  const { t } = useTranslation()

  const ukData = useUk()

  const { handleAddNotification, handleRemoveNotification, notifications } =
    useInlineNotifications({
      initialNotifications: getInitialNotifications(t),
    })

  const messageMaxLength = ukData.config.invite_max_length

  const validationSchema = getUserInvitationFormValidationSchema({
    messageMaxLength,
    t,
  })

  return (
    <FormikForm
      enableReinitialize
      Container={FormContainer}
      containerProps={containerProps}
      initialValues={initialValues}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      <UserInvitationFormFields
        {...restProps}
        messageMaxLength={messageMaxLength}
        notifications={notifications}
        setModal={setModal}
        onCancel={onCancel}
        onClose={onClose}
        onRemoveNotification={handleRemoveNotification}
        onSetNotification={handleAddNotification}
      />
    </FormikForm>
  )
}

export default UserInvitationForm
